let deferredInstallPrompt = null
let initialized = false
const subscribers = new Set()

const notifySubscribers = () => {
  subscribers.forEach((callback) => {
    try {
      callback(deferredInstallPrompt)
    } catch (_) {
      // Ignore subscriber failures.
    }
  })
}

export const initInstallPromptCapture = () => {
  if (initialized || typeof window === 'undefined') {
    return
  }

  initialized = true

  window.addEventListener('beforeinstallprompt', (event) => {
    deferredInstallPrompt = event
    notifySubscribers()
  })

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null
    notifySubscribers()
  })
}

export const getDeferredInstallPrompt = () => deferredInstallPrompt

export const clearDeferredInstallPrompt = () => {
  deferredInstallPrompt = null
  notifySubscribers()
}

export const subscribeInstallPrompt = (callback) => {
  subscribers.add(callback)
  return () => {
    subscribers.delete(callback)
  }
}
